module.exports = __webpack_public_path__ + "img/retail05.6ebd4865.png";